<template>
  <div class="item-list-filter-rooms" v-if="computedOptions.length > 0">
    <h2 v-if="roomsLabel" class="filter-label apartment-search-form__subtitle">{{ roomsLabel }}</h2>
    <div class="room-options">
      <button
        v-for="option in computedOptions"
        :key="option.value"
        class="room-option-btn"
        :class="{ 'is-selected': isSelected(option.value) }"
        @click="toggleOption(option.value)"
        type="button"
      >
        {{ option.label }}
      </button>
    </div>
  </div>
</template>

<script>
import utils from '../mixins/utils';

export default {
  name: "ItemListFilterRooms",
  mixins: [utils.translate],
  props: {
    // Vue 3 v-model uses modelValue. Expects an array of numbers, e.g., [2, 5]
    modelValue: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: null
    },
    // Apartments data to compute available room options
    apartments: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue'],
  computed: {
    roomsLabel() {
      return this.label || this.translate('Huoneita');
    },
    computedOptions() {

      // If no apartments provided, use default options
      if (!this.apartments || this.apartments.length === 0) {
        return [];
      }

      const suffix = this.translate('h (huonetta)');

      // Get unique room counts from apartments, group 5+ rooms together
      const roomCounts = [...new Set(this.apartments.map(apt => {
        const count = Number(apt.room_count);
        return count >= 5 ? 5 : count;
      }))].filter(count => count > 0).sort((a, b) => a - b);

      // Map to option format
      return roomCounts.map(count => ({
        value: count,
        label: count === 5 ? `5+${suffix}` : `${count}${suffix}`
      }));
    }
  },
  methods: {
    // Helper to check if an option is currently in the selected array
    isSelected(val) {
      return this.modelValue.includes(val);
    },
    // Handles button click: adds or removes the value from selection
    toggleOption(val) {
      let newSelection = [...this.modelValue]; // Clone existing array
      if (this.isSelected(val)) {
        // Remove selection
        newSelection = newSelection.filter(item => item !== val);
      } else {
        // Add selection
        newSelection.push(val);
      }
      // Update parent component (Vue 3 v-model pattern)
      this.$emit("update:modelValue", newSelection);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~styles/definitions";

.item-list-filter-rooms {

  .filter-label {
    font-size: 1.1rem;
    font-weight: bold;
    margin-bottom: 0.75rem;
    margin-top: 0;
  }

  .room-options {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem; // Creates space between buttons
  }

  .room-option-btn {
    background-color: transparent;
    border: 0.15rem solid $color-green-2025;
    padding: 0.6rem 1.2rem;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    min-width: 4.5rem;
    text-align: center;
    border-radius: 0;

    &:hover {
      background-color: $color-green-light-2025;
    }

    // Style for the selected state
    &.is-selected {
      background-color: $color-green-2025;
      color: white;
    }
    
    &:focus {
      outline: 0.15rem solid $color-green-2025;
      outline-offset: 0.15rem;
    }
  }
}
</style>
